export default "__VITE_ASSET__S9XjbCl2__"